export const convertToLocalTime = (utcTimestamp) => {
    const date = new Date(utcTimestamp);
    const options = { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone }; // Use browser's time zone
    return date.toLocaleString('en-US', options); // Convert to local time string
  };
  